import React from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { Minus, PackageOpen, Plus, ShieldCheck, Trash2, Truck, WalletCards } from "lucide-react";
import { CartListState } from "../../Atoms/CartAtom";
import "./style.css";

export default function Cart() {
  const history = useHistory();
  const [cart, setCart] = useRecoilState(CartListState);
  const previewOnly = cart.some(item => item.previewOnly);
  const subtotal = cart.reduce((total, item) => total + Number(item.price || 0) * Number(item.quantity || 1), 0);
  const shippingFee = subtotal >= 30000 || subtotal === 0 ? 0 : 3000;
  const totalPrice = subtotal + shippingFee;

  const removeItem = (productId) => {
    setCart(cart.filter((item) => item.product_id !== productId));
  };

  const updateQuantity = (productId, change) => {
    setCart(
      cart.map((item) =>
        item.product_id === productId
          ? { ...item, quantity: Math.max(1, Number(item.quantity || 1) + change) }
          : item
      )
    );
  };

  return (
    <main className="cart-page">
      <section className="cart-hero">
        <div>
          <span>SHOPPING BAG</span>
          <h1>장바구니</h1>
          <p>하나씩 모아둔 취향. 마지막으로 확인해보세요.</p>
        </div>
        <div className="cart-hero__count">{cart.length}<small>items</small></div>
      </section>

      {cart.length === 0 ? (
        <section className="cart-empty">
          <PackageOpen size={44} />
          <h2>장바구니가 비어 있습니다</h2>
          <p>추천 상품에서 마음에 드는 아이템을 담아보세요.</p>
          <button type="button" onClick={() => history.push("/Shop")}>쇼핑 계속하기</button>
        </section>
      ) : (
        <div className="cart-layout">
          <section className="cart-list" aria-label="장바구니 상품">
            {cart.map((item) => (
              <article className="cart-item" key={item.product_id}>
                <div className="cart-item__image">
                  {item.photo ? <img src={item.photo} alt={item.title || item.name} /> : <PackageOpen size={34} />}
                </div>
                <div className="cart-item__info">
                  <strong>{item.name}</strong>
                  <h2>{item.title || item.name}</h2>
                  <p>{item.previewOnly ? '디자인 미리보기 상품' : '기본 옵션'}</p>
                </div>
                <div className="cart-item__quantity">
                  <button type="button" aria-label={`${item.title || item.name} 수량 줄이기`} onClick={() => updateQuantity(item.product_id, -1)}><Minus size={15} /></button>
                  <span>{item.quantity}</span>
                  <button type="button" aria-label={`${item.title || item.name} 수량 늘리기`} onClick={() => updateQuantity(item.product_id, 1)}><Plus size={15} /></button>
                </div>
                <div className="cart-item__price">₩ {(Number(item.price || 0) * Number(item.quantity || 1)).toLocaleString("ko-KR")}</div>
                <button className="cart-item__remove" type="button" onClick={() => removeItem(item.product_id)} aria-label="상품 삭제">
                  <Trash2 size={17} />
                </button>
              </article>
            ))}
          </section>

          <aside className="cart-summary">
            <h2>결제 예정 금액</h2>
            <dl>
              <div><dt>상품 금액</dt><dd>₩ {subtotal.toLocaleString("ko-KR")}</dd></div>
              <div><dt>배송비</dt><dd>{shippingFee === 0 ? "무료" : `₩ ${shippingFee.toLocaleString("ko-KR")}`}</dd></div>
              <div><dt>할인</dt><dd>- ₩ 0</dd></div>
            </dl>
            <div className="cart-summary__total">
              <span>총 결제 금액</span>
              <strong>₩ {totalPrice.toLocaleString("ko-KR")}</strong>
            </div>
            <button type="button" disabled={previewOnly} onClick={() => history.push("/BuyItem")}>{previewOnly ? '미리보기 상품은 주문할 수 없습니다' : '주문하기'}</button>
            {previewOnly && <p className="am-preview-note">예시 상품을 제외하면 실제 상품 주문을 계속할 수 있습니다.</p>}
            <div className="cart-benefits">
              <div><ShieldCheck size={18} /> 정품 보장</div>
              <div><Truck size={18} /> 빠른 배송</div>
              <div><WalletCards size={18} /> 안전 결제</div>
            </div>
          </aside>
        </div>
      )}
    </main>
  );
}
